module.exports = __webpack_public_path__ + "img/galeria-captores-5.b50a2f9e.png";